/**
 * Первые минуты новичка (ISSUE-136): одна фраза предыстории поверх первого боя и момент, когда показывать закрытые
 * x2 и «Автонавыки». Флаги — на устройстве: пропущенная фраза или ранний замок на другом телефоне ничего не ломают.
 *
 * Предыстория — плашка {@link STORY_MS} поверх уже идущего боя волны 1, без паузы и кнопки, один раз и только новому
 * аккаунту: отдельный экран перед игрой в разборах FTUE давал отток (`.tasks/newfungame/context/ftue-research-2026-11-02.md`).
 *
 * Замки VIP — после первого таймера после падения штаба: до него игроку нечего ускорять. Вернувшийся на новом
 * устройстве с {@link VIP_TEASER_WAVE}+ таймер уже видел.
 */
import { createStore } from "./state/create-store";

export const STORY_KEY = "nfg:story";
export const TIMER_SEEN_KEY = "nfg:timerSeen";
export const STORY_MS = 4_000;
export const VIP_TEASER_WAVE = 10;

type Flags = Pick<Storage, "getItem" | "setItem">;

function storage(): Flags | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function read(key: string, s: Flags | null = storage()): boolean {
  try {
    return s?.getItem(key) === "1";
  } catch {
    return false;
  }
}

function write(key: string, s: Flags | null = storage()): void {
  try {
    s?.setItem(key, "1");
  } catch {
    // без localStorage флаг живёт до перезагрузки
  }
}

export interface FtueState {
  /** Фраза предыстории уже была на этом устройстве. */
  storyDone: boolean;
  /** Игрок хоть раз упирался в таймер после падения штаба. */
  timerSeen: boolean;
}

export const ftueStore = createStore<FtueState>({ storyDone: read(STORY_KEY), timerSeen: read(TIMER_SEEN_KEY) });

/** Показать фразу предыстории: аккаунт создан этим входом, идёт первая волна, фразы ещё не было. */
export function storyDue(args: { created: boolean; wave: number; bestWave: number; done: boolean }): boolean {
  return args.created && !args.done && args.wave === 1 && args.bestWave === 0;
}

export function finishStory(store = ftueStore): void {
  if (store.get().storyDone) return;
  write(STORY_KEY);
  store.set((s) => ({ ...s, storyDone: true }));
}

export function noteTimerSeen(store = ftueStore): void {
  if (store.get().timerSeen) return;
  write(TIMER_SEEN_KEY);
  store.set((s) => ({ ...s, timerSeen: true }));
}

/** Показывать ли закрытые x2 и «Автонавыки». */
export function vipTeaser(args: { timerSeen: boolean; lockNow: boolean; bestWave: number }): boolean {
  return args.timerSeen || args.lockNow || args.bestWave >= VIP_TEASER_WAVE;
}
